import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// Imports Toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/index.css";

// layouts
import Admin from "layouts/Admin";
import Auth from "layouts/Auth.js";

// Import du composant directement pour la route du mail
import ResetPasswordFinish from "views/auth/ResetPasswordFinish";

// Import de la protection
import ProtectedRoute from "components/ProtectedRoute";

ReactDOM.render(
  <BrowserRouter>
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        theme="colored"
      />

      <Switch>
        {/* 1. Les routes d'authentification sous /auth (login, request reset) */}
        <Route path="/auth" component={Auth} />

        {/* 2. Prise en charge directe de la route envoyée par l'email */}
        <Route path="/reset/finish" component={ResetPasswordFinish} />

        {/* 3. La zone d'administration protégée */}
        <ProtectedRoute path="/admin" component={Admin} />

        {/* 4. Redirections */}
        <Redirect exact from="/" to="/admin/dashboard" />
        <Redirect to="/auth/login" />
      </Switch>
    </>
  </BrowserRouter>,
  document.getElementById("root")
);